import { useCallback } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NoMatchView() {

    const navigate = useNavigate();
    const handleClick = useCallback(() => {
        navigate(-1);
    }, []);

    const { t } = useTranslation();
    return (
        <Box sx={{ textAlign:'center', alignItems: 'center' }}>
            <Typography>{t('NOT_FOUND.CONTENT')}</Typography>
            <Button onClick={handleClick}>{t('Go home')}</Button>
        </Box>
    );
}
